const UserActivity = "UserActivity";

export const SearchUserActivity = UserActivity + "/Search";
export const ExportSearchResults = UserActivity + "/ExportSearchResults";
export const CreateActivityLog = UserActivity + "/CreateActivityLog";